<template lang="html">
  <b-field>
    <template slot="label">
      Visibility
      <b-tooltip
        position="is-right"
        type="is-dark"
        multilined
        size="is-small"
        label="Change visiblity to public so that everyone can enjoy your progress!"
      >
        <b-icon size="is-small" type="is-gray" icon="help-circle-outline"></b-icon>
      </b-tooltip>
    </template>
    <b-switch
      v-model="localHidden"
      passive-type="is-warning"
      type="is-success"
      :true-value="false"
      :false-value="true"
      @input="updateHidden"
    >
      <span v-if="hidden">
        <b-icon size="" type="" icon="lock"></b-icon>
        Private
        <span class="is-italic"
          >(Only you can view this {{ itemType }} and its content)</span
        ></span
      >
      <span v-else>
        <b-icon size="" type="" icon="earth"></b-icon>
        Public
        <span class="is-italic"
          >(Everyone can view this {{ itemType }} and its content)</span
        >
      </span>
    </b-switch>
  </b-field>
</template>

<script>
export default {
  props: ['hidden', 'itemType'],
  data () {
    return {
      localHidden: null
    }
  },
  created () {
    this.localHidden = this.hidden
  },
  methods: {
    updateHidden (value) {
      this.$emit('updateHidden', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
